import { render, staticRenderFns } from "./LoadVehicleDetail.vue?vue&type=template&id=6e921e7c"
import script from "./LoadVehicleDetail.vue?vue&type=script&lang=js"
export * from "./LoadVehicleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports